import React from "react";

class TabsComments extends React.Component {
  componentDidMount() {
  }
  render() {
    return (
      <>
        {this.props.Comments.map((item) => (
          <div className="CommentsTabsMultiVendor">
            <div className="nameRate">
              <span>{item.customer.name}</span>
              <div className="rate">
                <span className="ratingNum">{item.rate}</span>
                <img src="/public/assets/icons/Rating.svg" alt="pic"/>
              </div>
            </div>
            <div className="commentsTitle">{item.content}</div>
            <div className="commentsTime">{item.date}</div>
          </div>
        ))}
      </>
    );
  }
}
export default TabsComments;
